import { z } from "zod";

// Format untuk YYYY-MM-DD
const monthYearRegex = /^\d{4}-\d{2}-\d{2}$/;

// Format UUID
const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const MonthResponseDataSchema = z.object({
    month_year: z.string().regex(monthYearRegex, "Invalid date format (YYYY-MM-DD expected)"),
    room_type_id: z.string().regex(uuidRegex, "Invalid UUID format"),
    room_type_name: z.string().min(1, "Room type name cannot be empty"),
    total_revenue: z.number().int().nonnegative(),
    avg_revenue: z.number().int().nonnegative(),
});

const PerRoomTypeSchema = z.object({
    room_type_id: z.string().regex(uuidRegex, "Invalid UUID format"),
    room_type_name: z.string().min(1, "Room type name cannot be empty"),
    total_revenue: z.number().int().nonnegative(),
    avg_revenue: z.number().int().nonnegative(),
});

const PerMonthSchema = z.object({
    month_year: z.string().regex(monthYearRegex, "Invalid date format (YYYY-MM-DD expected)"),
    total_revenue: z.number().int().nonnegative(),
    avg_revenue: z.number().int().nonnegative(),
});

export const MonthResponseSchema = z.object({
    success: z.boolean(),
    message: z.string().min(1, "Message cannot be empty"),
    code: z.number().int().positive().lte(599), // HTTP Code range: 1-599
    data: z.array(MonthResponseDataSchema),
    per_room_type: z.array(PerRoomTypeSchema),
    per_month: z.array(PerMonthSchema),
});

export type MonthResponse = z.infer<typeof MonthResponseSchema>;
export type MonthResponseData = z.infer<typeof MonthResponseDataSchema>;
export type PerRoomType = z.infer<typeof PerRoomTypeSchema>;
export type PerMonth = z.infer<typeof PerMonthSchema>;
